import { Grid } from "@material-ui/core";
import { round } from "lodash";
import React, { FunctionComponent, useContext } from "react";
import styled from "styled-components";
import { getOption } from "../../../../utils/utils";
import { StakeContext } from "../context";
import { StyledTextWidget } from "./tile";

interface IRewardsProps { }

const GridItem = styled(Grid).attrs({ item: true })`
  font-weight: bold;

  :nth-child(2n) {
    font-weight: 400;
  }
`;

const StyledGrid = styled(Grid).attrs({ container: true, spacing: 2 })`
  padding: 1em 0;
  text-align: center;
`;

const Rewards: FunctionComponent<IRewardsProps> = (props) => {
  const { currentContract } = useContext(StakeContext);

  return currentContract.fold(
    () => null,
    (contract) => (
      <StyledTextWidget title="Annual Reward Percentage">
        <StyledGrid>
          <GridItem xs={6}>Amount</GridItem>
          <GridItem xs={6}>Annual Bonus</GridItem>
          {([
            [
              "50K+",
              contract.rewardPercentageBreakdown.rewardAnnualAdopterPercentage,
            ],
            [
              "500K+",
              contract.rewardPercentageBreakdown.rewardAnnualInsiderPercentage,
            ],
            [
              "1.5M+",
              contract.rewardPercentageBreakdown
                .rewardAnnualEvangelistPercentage,
            ],
            [
              "3M+",
              contract.rewardPercentageBreakdown.rewardAnnualPartnerPercentage,
            ],
          ] as Array<[string, number]>).map(([tier, percentage]) => (
            <React.Fragment key={tier}>
              <GridItem xs={6}>{tier}</GridItem>
              <GridItem xs={6}>{percentage}%</GridItem>
            </React.Fragment>
          ))}
        </StyledGrid>
      </StyledTextWidget>
    )
  );
};

export default Rewards;
